// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"nL","cardInnerHeading":"nM","toggleWrapperClass":"nN","textWrapperClass":"nO","toggleTextClass":"nP"};